export const cardStyles = {
    py: 1,
    px: 2,
};
export const labelStyles = {
    pb: 1,
};
